import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .InnerTransfer {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: rem(25px);

    .InnerTransfer__line {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      :global(.ReduxSelectField, .ReduxTextField) {
        width: 400px;
        margin-right: rem(33px);
      }
    }

    .InnerTransfer__accounts-line {
      display: grid;
      grid-template-columns: 380px rem(34px) 380px;
      column-gap: rem(20px);
      align-items: center;
      width: max-content;
      max-width: 100%;

      :global(.ReduxSelectField) {
        width: 380px;
        margin-right: 0;
      }
    }

    .InnerTransfer__swap-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: rem(34px);
      height: rem(34px);
      background: transparent;
      cursor: pointer;
      transform: translateY(-14px);

      &:disabled {
        cursor: default;
        opacity: 0.4;
      }

      :global(svg) {
        width: rem(18px);
        height: rem(18px);
      }
    }

    @include respond-to(lg) {
      .InnerTransfer__accounts-line {
        grid-template-columns: minmax(0, 380px) rem(34px);
        row-gap: rem(15px);

        :global(.ReduxSelectField) {
          width: 100%;
        }
      }

      .InnerTransfer__swap-button {
        grid-column: 2;
        grid-row: 1 / 3;
        align-self: center;
      }
    }

    .InnerTransfer__description {
      display: flex;
      flex-direction: column;
      line-height: 1.5;
    }

    :global(.DefaultButton) {
      width: 120px;
      margin-top: rem(30px);
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .InnerTransfer {
      .InnerTransfer__description {
        color: ${colors.gray.hex};
      }

      .InnerTransfer__error {
        color: ${colors.error.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
